var startupFns = [];

class BESSApp extends BESSAppBase {
    static instance = null;

    constructor() {
        super();
        this.dev = false;
        this.googleMapsLoaded = false;
        this.sections = {
            auth: new BESSAppAuthSection(),
            project: new BESSAppProjectSection(),
            projects: new BESSAppProjectsSection(),
            search: new BESSAppSearchSection(),
        }
        this.managers = {
            profilers: new BESSAppProjectProfilersManager(),
            credits: new BESSAppProjectCreditManager(),
        }
    }

    start() {
        this.log('Loaded');
        this.services = {
            api: new BESSAppAPIService(),
        }

        this.sections.project.start();
        this.sections.projects.start();
        this.sections.search.start();
        this.managers.credits.start();
        this.managers.profilers.start();

        BESSAppComponent.initialiseAll();

        // accessibility helpers..
        let body = $('body');
        body.on('mousedown', function () {
            body.addClass('using-mouse');
        });

        body.on('keydown', function (event) {
            let key = event.key || event.keyCode;
            if (key === 'Tab' || key === 9) {
                body.removeClass('using-mouse');
            }
        });

        body.on('keyup', function (event) {
            let key = event.key || event.keyCode;
            if (key === 'Escape' || key === 27 || event.which === 27) {
                BESSAppUtils.dismissActivePopover();
            }
        });

        requestAnimationFrame(function () {
            if (location.hash) {
                const element = document.getElementById(location.hash.slice(1))

                if (element) {
                    element.scrollIntoView({behavior: 'smooth'});
                }
            }
        });
    }

    requireGoogleMaps(readyFn) {
        if (this.googleMapsLoaded) {
            readyFn();
            return;
        }
        let key = $('.app-google-maps-key').data('key');
        this.log("Using Google Maps Key " + key);

        $.getScript("https://maps.google.com/maps/api/js?key=" + key + "&libraries=places,marker&callback=gMapDone",
            function () {
                this.googleMapsLoaded = true;
                readyFn();
            }.bind(this));
    };
}

function gMapDone() {
    console.log("Google maps initialised");
}

$(document).ready(function () {
    BESSApp.instance = new BESSApp();
    BESSApp.instance.start();
    _.each(startupFns, function (startupFn) {
        startupFn(BESSApp.instance);
    });
    startupFns = [];
});

function bessAppInit(fn) {
    if (BESSApp.instance === null) {
        startupFns.push(fn);
    } else {
        fn(BESSApp.instance);
    }
}
